import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  return (
    <div className="container" style={{ padding: '100px 20px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '72px', marginBottom: '20px' }}>403</h1>
      <h2>Unauthorized Access</h2>
      <p style={{ marginBottom: '30px' }}>You don't have permission to access this page.</p>
      <Link to="/" className="btn btn-primary">
        Go Home
      </Link>
    </div>
  );
};

export default Unauthorized;
